import { createSvgComponent } from "../../icon/createSvgComponent";
import TabMoreFold from "@core/icon/assets/tab-more-fold.svg";
export default createSvgComponent(TabMoreFold);